"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var styles_1 = require("@mui/material/styles");
var classnames_1 = __importDefault(require("classnames"));
var react_router_dom_1 = require("react-router-dom");
var Money_1 = __importDefault(require("components/Money"));
var Text_1 = __importDefault(require("shared/components/Text"));
var PREFIX = 'StatBlock';
var classes = {
    title: "".concat(PREFIX, "-title"),
    root: "".concat(PREFIX, "-root"),
};
var StyledNavLinkReact = (0, styles_1.styled)(react_router_dom_1.NavLink)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b[".".concat(classes.title)] = {
            color: theme.palette.text.primary,
            fontWeight: theme.typography.fontWeightMedium,
            fontSize: '2rem',
            lineHeight: '1',
        },
        _b["&.".concat(classes.root)] = {
            padding: theme.spacing(3.5, 0, 2, 2),
            height: '100%',
            width: '100%',
            display: 'block',
            '&:hover': {
                textDecoration: 'none',
            },
        },
        _b);
});
var StatBlock = function (_a) {
    var _b;
    var item = _a.item, amountFormat = _a.amountFormat;
    return ((0, jsx_runtime_1.jsxs)(StyledNavLinkReact, __assign({ className: (0, classnames_1.default)('hov-parent', classes.root), to: item.link }, { children: [(item === null || item === void 0 ? void 0 : item.title) && (0, jsx_runtime_1.jsx)("h1", __assign({ className: classes.title }, { children: item === null || item === void 0 ? void 0 : item.title })), ((item === null || item === void 0 ? void 0 : item.amount) || (item === null || item === void 0 ? void 0 : item.amount) === 0) && ((0, jsx_runtime_1.jsx)("h2", __assign({ className: classes.title }, { children: (0, jsx_runtime_1.jsx)(Money_1.default, { amount: item === null || item === void 0 ? void 0 : item.amount, isShortened: !!amountFormat }) }))), ((item === null || item === void 0 ? void 0 : item.count) || (item === null || item === void 0 ? void 0 : item.count) === 0) && (0, jsx_runtime_1.jsx)("h2", __assign({ className: classes.title }, { children: item === null || item === void 0 ? void 0 : item.count })), (item === null || item === void 0 ? void 0 : item.description) && (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 2 }, { children: item === null || item === void 0 ? void 0 : item.description })), (_b = item === null || item === void 0 ? void 0 : item.descriptionTmpl) === null || _b === void 0 ? void 0 : _b.call(item, item === null || item === void 0 ? void 0 : item.actionCount)] })));
};
exports.default = StatBlock;
